import React, { Fragment, useEffect, useRef, useState } from 'react';
import LoadingBar from 'react-top-loading-bar'

import Header from '../Header';
import Footer from '../Footer';

export const Layout = ({ children }) => {
  const ref = useRef(null);
  const [isProgressVisible, setIsProgressVisible] = useState(true)

  useEffect(() => {
    if (ref.current) {
      ref.current.continuousStart(0, 200)
      setTimeout(() => ref.current.complete(), 1000);
    }
  }, [ref]);

  return (
    <Fragment>
      <Header />
      {isProgressVisible && (
        <LoadingBar color='#f11946' ref={ref} onLoaderFinished={() => setIsProgressVisible(false)} />
      )}
      <main>
        {children}
      </main>
      <Footer />
    </Fragment>
  );
}

export default Layout;